import React, { useEffect, useState } from 'react';
import { fetch_game_score } from "../Services/Service";
import { useNavigate } from 'react-router-dom';


const Game = ({ uuid }) => {

    const [flareUpStats, setFlareUpStats] = useState([]);
    const [loading, setLoading] = useState(false);
    const [target, setTarget] = useState('');

    console.log(flareUpStats, "flareUpStats")

    const navigate = useNavigate();



    useEffect(() => {
        const fetchDlqi = async () => {
            try {
                const dlqiResponse = await fetch_game_score({ uuid: uuid });
                console.log(dlqiResponse.data.data);
                setTarget(dlqiResponse.data.target[0].cognitiveTime)
                setFlareUpStats(dlqiResponse.data.data)
            } catch (error) {
                console.error(error);
            }
        };

        fetchDlqi();
    }, [uuid]);


    const formatDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const d = new Date(dateString.replace(/-/g, '/')); //IOS Date Compatibility issue resolved
        const day = String(d.getDate()).padStart(2, '0');
        const monthIndex = d.getMonth();
        const year = d.getFullYear();
        const monthName = months[monthIndex];
        return `${day}-${monthName}-${year}`;
    };

    const handleLog = () => {
        const url = `/report-flare-up?uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}`;
        navigate(url);
    };

    // Grouping flareUpStats by created date
    // const groupedByDate = flareUpStats.length >= 1 ? flareUpStats.reduce((acc, item) => {
    //     const date = formatDate(item.createdTime);
    //     if (!acc[date]) {
    //         acc[date] = [];
    //     }
    //     acc[date].push(item);
    //     return acc;
    // }, {}) : {};

    const formatDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const groupedByDate = flareUpStats.length >= 1 ? flareUpStats.reduce((acc, item) => {
        const date = formatDate(item.createdTime);
        if (!acc[date]) {
            acc[date] = { items: [], totalDuration: 0 };
        }
        acc[date].items.push(item);
        acc[date].totalDuration += Number(item.duration); // Ensure duration is treated as a number
        return acc;
    }, {}) : {};

    return (
        <div>
            {flareUpStats && flareUpStats.length >= 1 && !loading ?
                <section className="ReportGameStats Game">
                    <div className="container-fluid px-2">
                        {Object.entries(groupedByDate).map(([date, { items, totalDuration }]) => {
                            const totalDurationInMinutes = (totalDuration / 60).toFixed(2); // Convert to minutes and format to 2 decimal places
                            // const targetInMinutes = target.toFixed(2); // Format target to 2 decimal places
                            const totalDurationFormatted = formatDuration(totalDuration); // Format total duration as minutes:seconds
                            return (
                                <React.Fragment key={date}>
                                    <div className='row' style={{ backgroundColor: '#e4e9ed', borderRadius: "0px" }}>
                                        <div className='col-6'>
                                            <h2 className='user-date my-3'>{date}</h2>
                                        </div>
                                        <div className='col-6 d-flex align-items-center justify-content-end'>
                                            <h2 className='user-date my-3'>{totalDurationFormatted}/{target} minutes</h2>
                                        </div>
                                    </div>

                                    {items.map((item, index) => (
                                        <div key={index} className=' stats-border'>
                                            <h2 className='row ps-0 user-subtitle my-4' >
                                                <div className='col-5'>
                                                    Game Name:
                                                </div>
                                                <div className='col-7'>
                                                    <span>{item.gameName}</span>
                                                </div>
                                            </h2>
                                            <h2 className='row ps-0 user-subtitle my-4' >
                                                <div className='col-5'>
                                                    Duration:
                                                </div>
                                                <div className='col-7'>
                                                    <span>{item.duration} seconds</span>
                                                </div>
                                            </h2>
                                            <h2 className='row ps-0 user-subtitle my-4' >
                                                <div className='col-5'>
                                                    Cognitive Score:
                                                </div>
                                                <div className='col-7'>
                                                    <span>{item.cognitiveScore}</span>
                                                </div>
                                            </h2>

                                        </div>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </section> : flareUpStats != null && !loading ?
                    <section className="ReportFlareUpStats">
                        <div className='NoRecordFound'>
                            <div className='row'>
                                {/* <div className='col-12 text-center'>
                                    <img src={require('../images/icon-no-record-found.jpg')} className="record-img" alt="" />
                                </div> */}
                                <div className='col-12 text-center mt-4'>
                                    <h3>No Record Found</h3>
                                </div>
                            </div>
                        </div>
                    </section> : <div className="loader loader-bar">
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <img src='https://appcdn.goqii.com/storeimg/32388_1711621501.gif' alt='' />
                            </div>
                            <div className='col-12 text-center mt-4'>
                                <h3>Loading...</h3>
                            </div>
                        </div>
                    </div>
            }

        </div>
    )
}

export default Game
